import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'components';
import axios from 'axios';
import { useParams } from 'react-router';
import errorReporter from '@app/errorReporter';
import TourEditContext from '../TourEditContext';

const TourInvitePendingBuyers: React.FC = () => {
  const { tour, setTour, loading } = useContext(TourEditContext);
  const { tourId } = useParams<{ tourId: string }>();

  if (!tour?.pendingBuyers) return null;
  if (!tourId) return null;

  const invitePendingBuyers = () => {
    try {
      axios.post(`/tours/${tourId}/invite_pending_buyers`);
      setTour(prev => ({ ...prev, pendingBuyers: false }));
    } catch (err) {
      errorReporter.error(
        `Error inviting pending buyers to tour appointments: ${err}`,
      );
    }
  };

  return (
    <StyledContainer>
      <StyledLink onClick={() => invitePendingBuyers()} disabled={loading}>
        Invite
      </StyledLink>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  margin-top: 1px;
  margin-right: 20px;
`;

const StyledLink = styled(Link)`
  font-size: 15px;
  font-weight: 600;
  color: #236dfd;
`;

export default TourInvitePendingBuyers;
